import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/common/ui/select'
import { GetDynamicPageDataResponse } from '@/modules/client-setting/type'
import useMutationUpdateDynamicPage from '@/modules/client-setting/api/hooks/useMutationUpdateDynamicPage'
import { useQueryClient } from '@tanstack/react-query'
import { DynamicPageQueryKeys } from '@/modules/client-setting/keys'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'

interface DynamicPageSelectorProps {
	data: GetDynamicPageDataResponse[]
}

export default function DynamicPageSelector({
	data,
}: DynamicPageSelectorProps) {
	const { mutate: updateDynamicPage } = useMutationUpdateDynamicPage()
	const queryClient = useQueryClient()

	const activePageId = data.find((page) => page.isActive)?.id || ''

	const handleActivate = async (id: string) => {
		// First deactivate all pages
		for (const page of data) {
			if (page.isActive) {
				await updateDynamicPage(
					{
						id: page.id,
						payload: {
							isActive: false,
						},
					},
					{
						onError: (error) => {
							showErrorToast(error)
						},
					},
				)
			}
		}

		// Then activate the selected page
		updateDynamicPage(
			{
				id,
				payload: {
					isActive: true,
				},
			},
			{
				onSuccess: () => {
					toast.success('อัพเดทสถานะสำเร็จ')
					queryClient.invalidateQueries({
						queryKey: [DynamicPageQueryKeys.GetDynamicPage],
					})
				},
				onError: (error) => {
					showErrorToast(error)
				},
			},
		)
	}

	return (
		<div className="flex items-center gap-2">
			<span className="text-sm font-medium">เลือกหน้าที่จะเปิดใช้งาน:</span>
			<Select value={activePageId} onValueChange={handleActivate}>
				<SelectTrigger className="w-[200px]">
					<SelectValue placeholder="เลือกหน้าที่ต้องการใช้งาน" />
				</SelectTrigger>
				<SelectContent>
					{data.map((page) => (
						<SelectItem key={page.id} value={page.id}>
							{page.name}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	)
}
